  import axios from 'axios';
  //import { useState, useEffect } from 'react';
  import { BASE_PATH_API } from 'constants/env';
  import {
    transformListParams,
    transformListRes,
  } from 'services/commons/transformers';
  import { transformReviews, transformStats } from './transformers';

  export function totalinvitados(eventId, params = {}) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${eventId}/total-guests`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return null;
      });
  };

  export function estadisticainvitados(eventId, params = {}) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${eventId}/guest-statistics`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return null;
      });
  };

  export function botoninvitados(eventId, params = {}) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${eventId}/botoninvitados`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return null;
      });
  };

  export function infotabla(eventId, options) {
    if (options && 'page' in options) {
      const { page } = options;
      return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${eventId}?page_num=${page}`)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error('Error al cargar los datos de infotabla:', error);
          return false;
        });
    } else {
      return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${eventId}`)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.error('Error al cargar los datos de infotabla:', error);
          return false;
        });
    }
  };

  export function deleteInvitados (guestId) {
    return axios.delete(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/delete-guest`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return null;
      });
  }

  export function fechaInvitacion(eventId, params = {}) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${eventId}/invitation-date`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return error.data;
      });
  };

  export function obtenAcompanantes(guestId, params = {}) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/companion`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return error.response.data;;
      });
  };

  export function putGuestsDate (guestId, updatedData) {
    return axios.put(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/update-date`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        // Puedes agregar otras cabeceras aquí si es necesario
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return null;
      });
  }

  export function postGuests (guestId, updatedData) {
    return axios.post(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/guest-create`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        // Puedes agregar otras cabeceras aquí si es necesario
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return error.response.data;;
      });
  }

  export function postCompanion (guestId, updatedData) {
    return axios.post(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/companion-create`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        // Puedes agregar otras cabeceras aquí si es necesario
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return null;
      });
  }

  export function infoMiniTemplate(params = {}) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp-catalog-invitation-template`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return null;
      });
  };

  export function infoTemplate(templateId) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp-catalog-invitation-template/${templateId}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return null;
      });
  };

  export function postValidateExcel (guestId, updatedData) {
    return axios.post(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/validate-excel`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          // El servidor respondió con un código de estado HTTP 400 (Bad Request)
          console.error('postValidateExcel. Error de solicitud inválida:', error.response.data);
          return error.response.data; // Aquí puedes manejar los detalles específicos del error 400
        } else {
          // Otro tipo de error
          console.error('postValidateExcel. Error al actualizar los datos de postValidateExcel:', error);
          throw error; // Puedes optar por relanzar el error para manejarlo en otro lugar
        }
      });
  }

  export function postImportExcel(guestId, updatedData) {
    const requestConfig = {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 55000, // Tiempo de espera en milisegundos (55 segundos)
    };

    return axios.post(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/import-excel`, updatedData, requestConfig)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          // El servidor respondió con un código de estado HTTP 400 (Bad Request)
          console.error('postImportExcel. Error de solicitud inválida:', error.response.data);
          throw error.response.data; // Aquí puedes manejar los detalles específicos del error 400
        } else {
          // Otro tipo de error
          console.error('postImportExcel. Error al actualizar los datos de postImportExcel:', error);
          throw error; // Puedes optar por relanzar el error para manejarlo en otro lugar
        }
      });
  }

  export function postInvitation (guestId, updatedData) {
    return axios.post(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/invitation`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        // Puedes agregar otras cabeceras aquí si es necesario
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return error.response.data;
      });
  }

  export function infoInvitation(invitationId) {
    return axios.get(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${invitationId}/invitation`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al cargar los datos:', error);
        return error.response.data;
      });
  };

  export function putCompanion (companiontId, updatedData) {
    return axios.put(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${companiontId}/companion`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return error.response.data;
      });
  }

  export function putInvitationGuestStatus (guestId, updatedData) {
    return axios.put(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${guestId}/update-status`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return error.response.data;
      });
  }

  export function putSendInvitationNow (companionId, updatedData) {
    return axios.put(`${BASE_PATH_API}/gift-table/v1/gift-table-rsvp/${companionId}/send-invitation-now`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        // Puedes agregar otras cabeceras aquí si es necesario
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error('Error al actualizar los datos:', error);
        return null;
      });
  }